<template>
    <div>
        <div class='footer-column-title'>
            
        </div>
        <div class='footer-column-links'>
            
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        onClickLink(page) {
            this.$router.push(`/${page}`);
        }
    }
}
</script>